import * as React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import { useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import './styles.css';
import { dialogStyles } from './styles';

const Modal = (props) => {
	const { title, open, handleClose, showCloseIcon, actionButtons } = props;
	let actionButtonStyle = dialogStyles.actions;
	let paperPropsStyle = dialogStyles.paperProps.style;
	const isSmallScreen = useMediaQuery('(max-width:360px)');

	if (isSmallScreen) {
		paperPropsStyle = { ...paperPropsStyle, margin: 'unset', height: '100%' };
		actionButtonStyle = {
			...actionButtonStyle,
			justifyContent: 'space-around',
		};
	}

	return (
		<Dialog
			data-testid="modal"
			open={open}
			onClose={handleClose}
			PaperProps={{
				style: paperPropsStyle,
			}}
			BackdropProps={dialogStyles.backDropProps}
			disableEnforceFocus
			disableBackdropClick>
			{/* Dialog Title & Close Icon */}
			<DialogTitle
				style={dialogStyles.title}
				className="dialog-title"
				data-testid="dialog-title">
				{title}
				{showCloseIcon && (
					<IconButton
						data-testid="close-icon"
						aria-label="close"
						onClick={handleClose}
						style={{ marginRight: '10px' }}
						sx={dialogStyles.icon}>
						<CloseIcon style={dialogStyles.iconColor} />
					</IconButton>
				)}
			</DialogTitle>

			{/* Content */}
			<DialogContent style={dialogStyles.content}>
				{props.children}
			</DialogContent>

			{/* Action Buttons */}
			<DialogActions style={actionButtonStyle}>{actionButtons}</DialogActions>
		</Dialog>
	);
};

Modal.defaultProps = {
	showCloseIcon: true,
};

Modal.propTypes = {
	open: PropTypes.bool,
	title: PropTypes.element,
	handleClose: PropTypes.func,
	showCloseIcon: PropTypes.bool,
	actionButtons: PropTypes.element,
	children: PropTypes.any,
};

export default Modal;
